import React from 'react';

// AUTO GENERATED FILE 

import { AboutAnchorScrollNavbar } from './components/About/AboutAnchorScrollNavbar';
import { AboutBlog } from './components/About/AboutBlog';
import { AboutHero } from './components/About/AboutHero';
import { AboutHero2 } from './components/About/AboutHero2';
import { AboutManagement } from './components/About/AboutManagement';
import { AboutStory } from './components/About/AboutStory';
import { AboutTeam } from './components/About/AboutTeam';
import { AboutTeam2 } from './components/About/AboutTeam2';
import { AboutVision } from './components/About/AboutVision';
import { LeadingProofBox } from './components/About/LeadingProofBox';
import { Agenda } from './components/Agenda';
import { Apps } from './components/Apps';
import { AppsDocumentation } from './components/AppsDocumentation';
import { ArrayCTA } from './components/ArrayCTA';
import { BGImage } from './components/BGImage';
import { Banner2 } from './components/Banner2';
import { BorderWrapper } from './components/BorderWrapper';
import { Button } from './components/Button';
import { CTA } from './components/CTA';
import { CallToAction } from './components/CallToAction';
import { Callout } from './components/Callout';
import { Caption } from './components/Caption';
import { CategoryPosts } from './components/CategoryPosts';
import { Comparison } from './components/Comparison';
import { CompensationCalculator } from './components/CompensationCalculator';
import { CookieBanner2 } from './components/CookieBanner2';
import { DemoVideo } from './components/DemoVideo';
import { DocsGettingStarted } from './components/Docs/DocsGettingStarted';
import { DocsHero } from './components/Docs/DocsHero';
import { HandyLinks } from './components/Docs/HandyLinks';
import { ImportantLink } from './components/Docs/ImportantLink';
import { QuickLinks } from './components/Docs/QuickLinks';
import { Tutorials } from './components/Docs/Tutorials';
import { EventDisclaimer } from './components/EventDisclaimer';
import { EventFooter } from './components/EventFooter';
import { EventHero } from './components/EventHero';
import { EventRegistration } from './components/EventRegistration';
import { FAQAccordionGrid } from './components/FAQAccordionGrid';
import { FAQs } from './components/FAQs';
import { FeatureAvailability } from './components/FeatureAvailability';
import { FeatureSnapshot } from './components/FeatureSnapshot';
import { FilteredPosts } from './components/FilteredPosts';
import { FloatingButton } from './components/FloatingButton';
import { FooterCTA } from './components/FooterCTA';
import { GDPRForm } from './components/GDPRForm';
import { GetInTouch } from './components/GetInTouch';
import { Hero } from './components/Hero';
import { Hero3 } from './components/Hero3';
import { HiddenSection } from './components/HiddenSection';
import { HighlightBox } from './components/HighlightBox';
import { Home } from './components/Home';
import { HomeCTA } from './components/HomeCTA';
import { HomeCTA3 } from './components/HomeCTA3';
import { HowItWorks } from './components/HowItWorks';
import { HubSpotForm } from './components/HubSpotForm';
import { Image } from './components/Image';
import { LPCTA } from './components/LPCTA';
import { Link } from './components/Link';
import { LinkedinIcon } from './components/LinkedinIcon';
import { MarketLayout } from './components/MarketLayout';
import { NewsWrapper } from './components/NewsWrapper';
import { NewsletterForm } from './components/NewsletterForm';
import { NewsletterTutorial } from './components/NewsletterTutorial';
import { OverflowXSection } from './components/OverflowXSection';
import { PricingApproach } from './components/Pricing/PricingApproach';
import { PricingFooterCTA } from './components/Pricing/PricingFooterCTA';
import { Quote } from './components/Pricing/Quote';
import { ShowPlan } from './components/Pricing/ShowPlan';
import { PricingCTA } from './components/PricingCTA';
import { ProductCTA } from './components/ProductCTA';
import { ProductLayout } from './components/ProductLayout';
import { ProductOverview } from './components/ProductOverview';
import { QuickContact } from './components/QuickContact';
import { Quote2 } from './components/Quote2';
import { Section } from './components/Section';
import { SectionTitle } from './components/SectionTitle';
import { Sections } from './components/Sections';
import { Separator } from './components/Separator';
import { SimpleFeatures } from './components/SimpleFeatures';
import { Speakers } from './components/Speakers';
import { StarRepoButton } from './components/StarRepoButton';
import { SupportCTA } from './components/SupportCTA';
import { Testimonial } from './components/Testimonial';
import { TrackedCTA } from './components/TrackedCTA';
import { TracksCTA } from './components/TracksCTA';
import { Translation } from './components/Translation';
import { Tutorial } from './components/Tutorial';
import { TutorialsSlider } from './components/TutorialsSlider';
import { UnorderedList } from './components/UnorderedList';
import { VintageBox } from './components/VintageBox';
import { WhereWhen } from './components/WhereWhen';

export const shortcodes = (pageProps = {}) => ({
	AboutAnchorScrollNavbar: (props) => <AboutAnchorScrollNavbar {...props} {...pageProps} />,
	AboutBlog: (props) => <AboutBlog {...props} {...pageProps} />,
	AboutHero: (props) => <AboutHero {...props} {...pageProps} />,
	AboutHero2: (props) => <AboutHero2 {...props} {...pageProps} />,
	AboutManagement: (props) => <AboutManagement {...props} {...pageProps} />,
	AboutStory: (props) => <AboutStory {...props} {...pageProps} />,
	AboutTeam: (props) => <AboutTeam {...props} {...pageProps} />,
	AboutTeam2: (props) => <AboutTeam2 {...props} {...pageProps} />,
	AboutVision: (props) => <AboutVision {...props} {...pageProps} />,
	LeadingProofBox: (props) => <LeadingProofBox {...props} {...pageProps} />,
	Agenda: (props) => <Agenda {...props} {...pageProps} />,
	Apps: (props) => <Apps {...props} {...pageProps} />,
	AppsDocumentation: (props) => <AppsDocumentation {...props} {...pageProps} />,
	ArrayCTA: (props) => <ArrayCTA {...props} {...pageProps} />,
	BGImage: (props) => <BGImage {...props} {...pageProps} />,
	Banner2: (props) => <Banner2 {...props} {...pageProps} />,
	BorderWrapper: (props) => <BorderWrapper {...props} {...pageProps} />,
	Button: (props) => <Button {...props} {...pageProps} />,
	CTA: (props) => <CTA {...props} {...pageProps} />,
	CallToAction: (props) => <CallToAction {...props} {...pageProps} />,
	Callout: (props) => <Callout {...props} {...pageProps} />,
	Caption: (props) => <Caption {...props} {...pageProps} />,
	CategoryPosts: (props) => <CategoryPosts {...props} {...pageProps} />,
	Comparison: (props) => <Comparison {...props} {...pageProps} />,
	CompensationCalculator: (props) => <CompensationCalculator {...props} {...pageProps} />,
	CookieBanner2: (props) => <CookieBanner2 {...props} {...pageProps} />,
	DemoVideo: (props) => <DemoVideo {...props} {...pageProps} />,
	DocsGettingStarted: (props) => <DocsGettingStarted {...props} {...pageProps} />,
	DocsHero: (props) => <DocsHero {...props} {...pageProps} />,
	HandyLinks: (props) => <HandyLinks {...props} {...pageProps} />,
	ImportantLink: (props) => <ImportantLink {...props} {...pageProps} />,
	QuickLinks: (props) => <QuickLinks {...props} {...pageProps} />,
	Tutorials: (props) => <Tutorials {...props} {...pageProps} />,
	EventDisclaimer: (props) => <EventDisclaimer {...props} {...pageProps} />,
	EventFooter: (props) => <EventFooter {...props} {...pageProps} />,
	EventHero: (props) => <EventHero {...props} {...pageProps} />,
	EventRegistration: (props) => <EventRegistration {...props} {...pageProps} />,
	FAQAccordionGrid: (props) => <FAQAccordionGrid {...props} {...pageProps} />,
	FAQs: (props) => <FAQs {...props} {...pageProps} />,
	FeatureAvailability: (props) => <FeatureAvailability {...props} {...pageProps} />,
	FeatureSnapshot: (props) => <FeatureSnapshot {...props} {...pageProps} />,
	FilteredPosts: (props) => <FilteredPosts {...props} {...pageProps} />,
	FloatingButton: (props) => <FloatingButton {...props} {...pageProps} />,
	FooterCTA: (props) => <FooterCTA {...props} {...pageProps} />,
	GDPRForm: (props) => <GDPRForm {...props} {...pageProps} />,
	GetInTouch: (props) => <GetInTouch {...props} {...pageProps} />,
	Hero: (props) => <Hero {...props} {...pageProps} />,
	Hero3: (props) => <Hero3 {...props} {...pageProps} />,
	HiddenSection: (props) => <HiddenSection {...props} {...pageProps} />,
	HighlightBox: (props) => <HighlightBox {...props} {...pageProps} />,
	Home: (props) => <Home {...props} {...pageProps} />,
	HomeCTA: (props) => <HomeCTA {...props} {...pageProps} />,
	HomeCTA3: (props) => <HomeCTA3 {...props} {...pageProps} />,
	HowItWorks: (props) => <HowItWorks {...props} {...pageProps} />,
	HubSpotForm: (props) => <HubSpotForm {...props} {...pageProps} />,
	Image: (props) => <Image {...props} {...pageProps} />,
	LPCTA: (props) => <LPCTA {...props} {...pageProps} />,
	Link: (props) => <Link {...props} {...pageProps} />,
	LinkedinIcon: (props) => <LinkedinIcon {...props} {...pageProps} />,
	MarketLayout: (props) => <MarketLayout {...props} {...pageProps} />,
	NewsWrapper: (props) => <NewsWrapper {...props} {...pageProps} />,
	NewsletterForm: (props) => <NewsletterForm {...props} {...pageProps} />,
	NewsletterTutorial: (props) => <NewsletterTutorial {...props} {...pageProps} />,
	OverflowXSection: (props) => <OverflowXSection {...props} {...pageProps} />,
	PricingApproach: (props) => <PricingApproach {...props} {...pageProps} />,
	PricingFooterCTA: (props) => <PricingFooterCTA {...props} {...pageProps} />,
	Quote: (props) => <Quote {...props} {...pageProps} />,
	ShowPlan: (props) => <ShowPlan {...props} {...pageProps} />,
	PricingCTA: (props) => <PricingCTA {...props} {...pageProps} />,
	ProductCTA: (props) => <ProductCTA {...props} {...pageProps} />,
	ProductLayout: (props) => <ProductLayout {...props} {...pageProps} />,
	ProductOverview: (props) => <ProductOverview {...props} {...pageProps} />,
	QuickContact: (props) => <QuickContact {...props} {...pageProps} />,
	Quote2: (props) => <Quote2 {...props} {...pageProps} />,
	Section: (props) => <Section {...props} {...pageProps} />,
	SectionTitle: (props) => <SectionTitle {...props} {...pageProps} />,
	Sections: (props) => <Sections {...props} {...pageProps} />,
	Separator: (props) => <Separator {...props} {...pageProps} />,
	SimpleFeatures: (props) => <SimpleFeatures {...props} {...pageProps} />,
	Speakers: (props) => <Speakers {...props} {...pageProps} />,
	StarRepoButton: (props) => <StarRepoButton {...props} {...pageProps} />,
	SupportCTA: (props) => <SupportCTA {...props} {...pageProps} />,
	Testimonial: (props) => <Testimonial {...props} {...pageProps} />,
	TrackedCTA: (props) => <TrackedCTA {...props} {...pageProps} />,
	TracksCTA: (props) => <TracksCTA {...props} {...pageProps} />,
	Translation: (props) => <Translation {...props} {...pageProps} />,
	Tutorial: (props) => <Tutorial {...props} {...pageProps} />,
	TutorialsSlider: (props) => <TutorialsSlider {...props} {...pageProps} />,
	UnorderedList: (props) => <UnorderedList {...props} {...pageProps} />,
	VintageBox: (props) => <VintageBox {...props} {...pageProps} />,
	WhereWhen: (props) => <WhereWhen {...props} {...pageProps} />,
});
